import Header from "../Header";

import SidebarMenuProvider, {
  SidebarMenuContext,
} from "contexts/SidebarMenuContext";

import { useContext, useEffect, useState } from "react";
import clsx from "clsx";
import Sidebar from "../Sidebar";
import { Outlet } from "react-router-dom";
import TabsMenuProvider from "contexts/TabsMenuContext";
import { useIsMobile } from "utils/useIsMobile";
import MobilePrivateLayout from "components/Layouts/mobile/MobilePrivateLayout";
import PrivateFooter from "components/Layouts/PrivateFooter";

type PrivatePageCommonTypes = React.PropsWithChildren &
  React.HTMLAttributes<HTMLDivElement>;

interface PrivateTypes extends PrivatePageCommonTypes {}

const PrivateLayout = (props: PrivateTypes) => {
  const { children, className } = props;
  //   const { user, coreConfig } = useAuth();
  //   const router = useRouter();
  const sidebarMenuContext = useContext(SidebarMenuContext);

  const { isMobile } = useIsMobile();

  //   useEffect(
  //     () => {
  //       if (!router.isReady) {
  //         return;
  //       }
  //       if (
  //         user === null &&
  //         !window.localStorage.getItem("userToken") &&
  //         router.asPath !== "/authentication/logincallback"
  //       ) {
  //         if (router.asPath !== "/") {
  //           router.replace({
  //             pathname: "/login",
  //             query: { returnUrl: router.asPath },
  //           });
  //         } else {
  //           router.replace("/login");
  //         }
  //       }
  //     },
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //     [router]
  //   );

  if (isMobile) {
    return (
      <TabsMenuProvider>
        <MobilePrivateLayout>
          <Outlet />
        </MobilePrivateLayout>
      </TabsMenuProvider>
    );
  }

  return (
    // <SidebarMenuProvider>
    <TabsMenuProvider>
      {/*<div style={{ border: "3px solid red" }}>*/}
      <main className="h-screen flex flex-col bg-neutral-15">
        <Header
          className={clsx(
            sidebarMenuContext.expand
              ? "w-[calc(100%-260px)] mr-[260px]"
              : "w-[calc(100%-56px)] mr-[56px]"
            // "transition-all duration-300"
          )}
        />
        <Sidebar />
        <div
          className={clsx(
            "relative flex flex-grow flex-1 flex-col bg-neutral-15 min-h-[700px]",
            className,
            sidebarMenuContext.expand && "mr-[260px]",
            !sidebarMenuContext.expand && "mr-[57px]"
          )}
        >
          {/*<main>*/}
          <Outlet />
          {/*</main>*/}
          {/*{children}*/}
        </div>
        <PrivateFooter />
      </main>
      {/*</div>*/}
    </TabsMenuProvider>
    // </SidebarMenuProvider>
  );
};

export default PrivateLayout;
